import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { INTERNAL_LOGIN_URL, logoutURL, SSO_LOGIN_URL } from '../../../NonReact/constants/ApiConstants'
import { redirectToServlet, ServletCmds } from '../../../NonReact/constants/ServletCommands'
import { displayError } from '../Utils/Messages'
import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { getSession } from './CommonAPI'
import { isVarNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { RouteID } from '../../../ReactRouting/Components/Molecules/Header/Types/Types'
import { APIData, JSONResponse } from '../../../NonReact/common/Types/Types'

export type LoginResponse = {
    RedirectThePageTo: RouteID
    MainTitle?: string
    PageTitle?: string
    Message?: string
}

export type SsoLoginResponse = {
    sessionId: string
    otherSessionsClosed: boolean
}

export const signInWithMsal = (accessToken: string): Promise<JSONResponse<SsoLoginResponse>> =>
    requestGetJSON<JSONResponse<SsoLoginResponse>>(SSO_LOGIN_URL, {
        headers: { 'x-msal-access-token': accessToken }
    })

export const signIn = (username: string, password: string, locale?: string): Promise<Nullable<LoginResponse>> =>
    getSession().then(
        (): Promise<Nullable<LoginResponse>> =>
            requestJSON<Nullable<APIData<LoginResponse>>>(INTERNAL_LOGIN_URL, {
                method: RESTMethods.POST,
                body: {
                    username,
                    plainTextPassword: password,
                    locale
                }
            }).then((response: Nullable<APIData<LoginResponse>>): Nullable<LoginResponse> => response?.Data)
    )

/**
 * Sign out of Akixi.
 */
export const signOut = (doRedirect?: () => void): void => {
    requestGetJSON(logoutURL)
        .then((): void => {
            setTimeout(
                (): void => (isVarNotEmpty(doRedirect) ? doRedirect() : redirectToServlet(ServletCmds.AUTHENTICATION)),
                100
            )
        })
        .catch((error: Error): void => {
            displayError(error)
            setTimeout(
                (): void => (isVarNotEmpty(doRedirect) ? doRedirect() : redirectToServlet(ServletCmds.AUTHENTICATION)),
                1000
            )
        })
}
